// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.order-payment-section {
  width: 100%;
}
.order-payment-section .section-title {
  display: flex;
  align-items: center;
}
.order-payment-section .section-title .vert-icon {
  margin-right: var(--spacing-small);
}
.order-payment-section .section-title .vert-icon svg {
  fill: var(--color-neutral-dark);
}
.order-payment-section .container .card-related {
  padding-right: var(--spacing-regular) !important;
}
.order-payment-section .container .card-related .payment-info {
  font-weight: 700;
  color: var(--color-neutral-dark);
}
.order-payment-section .container .card-related .card-infos {
  margin-top: var(--spacing-small);
  display: flex;
  align-items: center;
  gap: var(--spacing-small);
}
.order-payment-section .container .card-related .card-infos .card-brand {
  width: 40px;
  padding: 3px;
  border: 1px solid var(--color-border);
  display: flex;
  justify-content: center;
  align-items: center;
}
.order-payment-section .container .card-related .status {
  margin-top: var(--spacing-small);
}
.order-payment-section .container .card-related .status.approved {
  color: var(--color-success);
}
.order-payment-section .container .points-related .payment-info {
  font-weight: 700;
  color: var(--color-neutral-dark);
}
.order-payment-section .container .points-related .payment-info.cost {
  color: var(--color-error);
}
.order-payment-section .container .points-related .payment-info.revenue,
.order-payment-section .container .points-related .payment-info.free {
  color: var(--color-success);
}
.order-payment-section .container .points-related .payment-info .add-on {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}
.order-payment-section .container .points-related .between {
  display: flex;
  justify-content: space-between;
  gap: var(--spacing-small);
}
.order-payment-section .container .points-related .between.bold {
  font-weight: 700;
}
.order-payment-section .container .points-related .final-values {
  margin-top: var(--spacing-small);
}
@media (min-width: 576px) {
  .order-payment-section .container .points-related {
    padding-left: var(--spacing-regular) !important;
    border-left: 1px solid var(--color-border);
  }
}
@media (max-width: 576px) {
  .order-payment-section .container .points-related {
    margin-top: var(--spacing-regular);
  }
}
`, "",{"version":3,"sources":["webpack://./src/Assets/styles/default/components/Orders/OrderDetails/OrderPayment/styles.less"],"names":[],"mappings":"AAAA;EACE,WAAA;AACF;AAFA;EAII,aAAA;EACA,mBAAA;AACJ;AANA;EAQM,kCAAA;AACN;AATA;EAWQ,+BAAA;AACR;AAZA;EAkBM,gDAAA;AAHN;AAfA;EAqBQ,gBAAA;EACA,gCAAA;AAHR;AAnBA;EA0BQ,gCAAA;EAEA,aAAA;EACA,mBAAA;EACA,yBAAA;AALR;AAzBA;EAiCU,WAAA;EACA,YAAA;EACA,qCAAA;EAEA,aAAA;EACA,uBAAA;EACA,mBAAA;AANV;AAjCA;EA4CQ,gCAAA;AARR;AAUQ;EACE,2BAAA;AARV;AAvCA;EAsDQ,gBAAA;EACA,gCAAA;AAZR;AAcQ;EACE,yBAAA;AAZV;AAeQ;;EAEE,2BAAA;AAbV;AAlDA;EAmEU,aAAA;EACA,sBAAA;EACA,qBAAA;AAdV;AAvDA;EA0EQ,aAAA;EACA,8BAAA;EACA,yBAAA;AAhBR;AAkBQ;EACE,gBAAA;AAhBV;AA/DA;EAoFQ,gCAAA;AAlBR;AAqBM;EAAA;IACE,+CAAA;IACA,0CAAA;EAlBN;AACF;AAoBM;EAAA;IACE,kCAAA;EAjBN;AACF","sourcesContent":[".order-payment-section {\n  width: 100%;\n\n  .section-title {\n    display: flex;\n    align-items: center;\n\n    .vert-icon {\n      margin-right: var(--spacing-small);\n\n      svg {\n        fill: var(--color-neutral-dark);\n      }\n    }\n  }\n\n  .container {\n    .card-related {\n      padding-right: var(--spacing-regular) !important;\n\n      .payment-info {\n        font-weight: 700;\n        color: var(--color-neutral-dark);\n      }\n\n      .card-infos {\n        margin-top: var(--spacing-small);\n\n        display: flex;\n        align-items: center;\n        gap: var(--spacing-small);\n\n        .card-brand {\n          width: 40px;\n          padding: 3px;\n          border: 1px solid var(--color-border);\n\n          display: flex;\n          justify-content: center;\n          align-items: center;\n        }\n      }\n\n      .status {\n        margin-top: var(--spacing-small);\n\n        &.approved {\n          color: var(--color-success);\n        }\n      }\n    }\n\n    .points-related {\n      .payment-info {\n        font-weight: 700;\n        color: var(--color-neutral-dark);\n\n        &.cost {\n          color: var(--color-error);\n        }\n\n        &.revenue,\n        &.free {\n          color: var(--color-success);\n        }\n\n        .add-on {\n          display: flex;\n          flex-direction: column;\n          align-items: flex-end;\n        }\n      }\n\n      .between {\n        display: flex;\n        justify-content: space-between;\n        gap: var(--spacing-small);\n\n        &.bold {\n          font-weight: 700;\n        }\n      }\n\n      .final-values {\n        margin-top: var(--spacing-small);\n      }\n\n      @media (min-width: 576px) {\n        padding-left: var(--spacing-regular) !important;\n        border-left: 1px solid var(--color-border);\n      }\n\n      @media (max-width: 576px) {\n        margin-top: var(--spacing-regular);\n      }\n    }\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
